<script>
    export let label = 'Select Me';
    export let checked = false;
    export let showTooltip = false;
    export let tooltipTitle = 'title';
    export let tooltipContent = 'description';
    export let position = 'right';
    export let disabled = false;

    export let backgroundColor = '#8001BD';

    export let widgetClass = '';

</script>


<div class={`widget-wrap ${widgetClass}`}>
    <label class="form-switch">
        <input type="checkbox" bind:checked={checked} disabled={disabled} />
        <i class={position === 'right' ? 'toggle-right' : 'toggle-left'}></i>

        <span>
            {label}
            {#if showTooltip}
                <img class="qimages"
                     src="/images/red-help.png"
                     alt=""
                     data-toggle="popover"
                     title=""
                     data-content={tooltipContent}
                     data-original-title={tooltipTitle}
                />
            {/if}
        </span>
    </label>
</div>

<div style='--backgroundColor:{backgroundColor};'></div>

<style>
    .toggle-right {
        margin-left: auto;
        order: 2;
    }
    .form-switch {
        /*display: inline-block;*/
        display: flex;
        cursor: pointer;
        width: 100%;
        -webkit-tap-highlight-color: transparent;
        align-items: center;
    }
    .form-switch i {
        position: relative;
        display: inline-block;
        margin-right: .5rem;
        width: 46px;
        height: 26px;
        background-color: #e6e6e6;
        border-radius: 23px;
        vertical-align: text-bottom;
        transition: all 0.3s linear;
    }
    .form-switch i::before {
        content: "";
        position: absolute;
        left: 0;
        width: 42px;
        height: 22px;
        background-color: #fff;
        border-radius: 11px;
        transform: translate3d(2px, 2px, 0) scale3d(1, 1, 1);
        transition: all 0.25s linear;
    }
    .form-switch i::after {
        content: "";
        position: absolute;
        left: 0;
        width: 22px;
        height: 22px;
        background-color: #fff;
        border-radius: 11px;
        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.24);
        transform: translate3d(2px, 2px, 0);
        transition: all 0.2s ease-in-out;
    }
    .form-switch:active i::after {
        width: 28px;
        transform: translate3d(2px, 2px, 0);
    }
    .form-switch:active input:checked + i::after { transform: translate3d(16px, 2px, 0); }
    .form-switch input { display: none; }
    .form-switch input:checked + i { background-color: var(--backgroundColor, #8001BD); }
    .form-switch input:checked + i::before { transform: translate3d(18px, 2px, 0) scale3d(0, 0, 0); }
    .form-switch input:checked + i::after { transform: translate3d(22px, 2px, 0); }
</style>